import { createContext } from 'react'
import { CardType } from '../../../constants/Constants'

const CardTypeContext = createContext(CardType.EMPHASIZE)

export default CardTypeContext
